import React from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppIcon, EmailIcon, PhoneIcon, LocationIcon, ClockIcon } from './Icons';
import './Footer.css';

const Footer = () => {
  const WHATSAPP_DISPLAY = '060 938 2465';
  const WHATSAPP_LINK = 'https://wa.me/27609382465';
  const LANDLINE_DISPLAY = '010 500 0105';
  const LANDLINE_LINK = 'tel:+27105000105';
  const ADDRESS_TEXT = '138 Walton Ave, Carlswald, Midrand, 1684';
  const MAPS_LINK = 'https://www.google.com/maps/search/?api=1&query=138+Walton+Ave,+Carlswald,+Midrand,+1684';

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">

          {/* Brand */}
          <div className="footer-section">
            <div className="footer-logo">
              <h3>Pure Drop</h3>
              <span>Technicals</span>
            </div>
            <p>
              Professional water shop installations, commercial purification plants, and complete
              turnkey water solutions across South Africa.
            </p>
            <div className="social-links">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                <WhatsAppIcon size={16} className="social-icon" /> WhatsApp
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/request">Get Quote</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Water Shop Installations</li>
              <li>Commercial Purification Plants</li>
              <li>Containerized Water Systems</li>
              <li>Home RO Installations</li>
              <li>Borehole Water Solutions</li>
              <li>Ice Machines & Cold Chain</li>
              <li>Maintenance & Support</li>
              <li>Training & Compliance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>
                <EmailIcon size={16} className="contact-icon" />{' '}
                <a href="mailto:info@watershopinstallations.co.za">
                  info@watershopinstallations.co.za
                </a>
              </p>
              <p>
                <PhoneIcon size={16} className="contact-icon" />{' '}
                <a href={LANDLINE_LINK}>{LANDLINE_DISPLAY}</a>
              </p>
              <p>
                <WhatsAppIcon size={16} className="contact-icon" />{' '}
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                  {WHATSAPP_DISPLAY}
                </a>
              </p>
              <p>
                <LocationIcon size={16} className="contact-icon" />{' '}
                <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer">
                  {ADDRESS_TEXT}
                </a>
              </p>
              <p>
                <ClockIcon size={16} className="contact-icon" />{' '}
                Mon–Fri: 8:30 AM–5:00 PM • Sat: 8:30 AM–1:00 PM • Sun: Closed
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2025 Pure Drop Technicals Pty Ltd. All rights reserved.</p>
            <p>Professional water solutions across South Africa | www.watershopinstallations.co.za</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;